import { useMemo } from 'react';

import { useAppSelector } from 'js/store/hooks';

import { UserWithPermissions, getUserWithPermissions } from './permissionsHelpers';

const useUserWithPermissions = (): UserWithPermissions => {
  const user = useAppSelector(state => state.auth).currentUser;

  return useMemo(() => {
    return getUserWithPermissions(user);
  }, [user]);
};

export default useUserWithPermissions;
